import { render, staticRenderFns } from "./TradeS2S.vue?vue&type=template&id=f9ba43cc&"
import script from "./TradeS2S.vue?vue&type=script&lang=js&"
export * from "./TradeS2S.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports